import { remapData } from '~/utils';
import * as types from './types';

const INITIAL_STATE = {
  expediteMaterials: [],
  originalExpediteMaterials: [],
  isExpediteMaterialsDirty: false,
  expediteDailyParts: [],
  expediteDailyPartsFilters: {},
  originalExpediteDailyParts: [],
  isExpediteDailyPartsDirty: false,
  pagination: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_EXPEDITE_MATERIALS_LIST: {
      return {
        ...state,
        expediteMaterials: [...action.payload.data],
        originalExpediteMaterials: [...action.payload.data],
      };
    }
    case types.ADD_EXPEDITE_MATERIAL: {
      const newExpediteMaterial = {
        ...action.payload,
        id: 0 - state.expediteMaterials.length,
        update_status: 'I',
        isDirty: true,
      };
      return {
        ...state,
        expediteMaterials: [newExpediteMaterial, ...state.expediteMaterials],
        isExpediteMaterialsDirty: true,
      };
    }
    case types.UPDATE_EXPEDITE_MATERIAL: {
      const newExpediteMaterial = {
        ...action.payload,
        isDirty: true,
      };
      const newData = remapData(state.expediteMaterials, newExpediteMaterial, 'id');
      return {
        ...state,
        expediteMaterials: newData,
        isExpediteMaterialsDirty: true,
      };
    }
    case types.RESET_EXPEDITE_MATERIALS_LIST: {
      return {
        ...state,
        isExpediteMaterialsDirty: false,
        expediteMaterials: [...state.originalExpediteMaterials],
      };
    }
    case types.SET_EXPEDITE_DAILY_PARTS_LIST: {
      const { data, reorder = true } = action.payload;
      let expediteDailyParts = [];
      let originalExpediteDailyParts = [];

      if (reorder) {
        expediteDailyParts = [...data];
        originalExpediteDailyParts = [...data];
      } else {
        expediteDailyParts = [...state.expediteDailyParts, ...data];
        originalExpediteDailyParts = [...state.originalExpediteDailyParts, ...data];
      }

      return {
        ...state,
        expediteDailyParts,
        originalExpediteDailyParts,
        isExpediteDailyPartsDirty: false,
      };
    }
    case types.ADD_EXPEDITE_DAILY_PART: {
      const newExpediteDailyPart = {
        ...action.payload,
        id: 0 - state.expediteDailyParts.length,
        update_status: 'I',
        isDirty: true,
      };
      return {
        ...state,
        expediteDailyParts: [newExpediteDailyPart, ...state.expediteDailyParts],
        isExpediteDailyPartsDirty: true,
      };
    }
    case types.UPDATE_EXPEDITE_DAILY_PART: {
      const newExpediteDailyPart = {
        ...action.payload,
        isDirty: true,
      };
      const newData = remapData(state.expediteDailyParts, newExpediteDailyPart, 'id');
      return {
        ...state,
        expediteDailyParts: newData,
        isExpediteDailyPartsDirty: true,
      };
    }
    case types.DELETE_EXPEDITE_DAILY_PART: {
      let data = [];
      if (action.payload.id <= 0) {
        data = state.expediteDailyParts.filter(l => l.id !== action.payload.id);
      } else {
        data = remapData(state.expediteDailyParts, action.payload, 'id');
      }
      return {
        ...state,
        expediteDailyParts: [...data],
        isExpediteDailyPartsDirty: true,
      };
    }
    case types.SET_EXPEDITE_DAILY_PARTS_FILTERS: {
      return {
        ...state,
        expediteDailyPartsFilters: action.payload,
      };
    }
    case types.RESET_EXPEDITE_DAILY_PARTS_LIST: {
      return {
        ...state,
        isExpediteDailyPartsDirty: false,
        expediteDailyParts: [...state.originalExpediteDailyParts],
      };
    }
    case types.CLEAN_EXPEDITE_DAILY_PARTS_LIST: {
      return {
        ...state,
        expediteDailyParts: [],
        originalExpediteDailyParts: [],
        isExpediteDailyPartsDirty: false,
      };
    }
    case types.SET_PAGINATION_VALUES: {
      const { listType, ...rest } = action.payload;
      const formattedListTypes = `${listType}Pagination`;
      const foundPaginationData = state.pagination[formattedListTypes];

      if (foundPaginationData === undefined) {
        return {
          ...state,
          pagination: {
            ...state.pagination,
            [formattedListTypes]: { ...rest, batchPages: [0] },
          },
        };
      }

      const lastPage = foundPaginationData.batchPages.at(-1);

      return {
        ...state,
        pagination: {
          ...state.pagination,
          [formattedListTypes]: {
            ...rest,
            batchPages: [...foundPaginationData.batchPages, lastPage + 1],
          },
        },
      };
    }
    case types.UPDATE_PAGINATION_VALUES: {
      const { listType, ...rest } = action.payload;
      const formattedListTypes = `${listType}Pagination`;
      const foundPaginationData = state.pagination[formattedListTypes];

      if (foundPaginationData === undefined) return state;

      return {
        ...state,
        pagination: {
          ...state.pagination,
          [formattedListTypes]: {
            ...foundPaginationData,
            ...rest,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
}
